import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { key: 4 }

import { ref, onMounted } from 'vue'
import BannerCard from './components/bannerCard.vue'
import CarousalCard from './components/carousalCard.vue'
import NoticeBar from './components/noticeBar.vue'
import GroupList from './components/groupList.vue'
import GamePanel from './components/gamePanel.vue'
import FooterText from './components/footerText.vue'
import PromotionPopup from '@/view/promotion/promotionPopup.vue'
import FloatButton from './components/floatButton.vue'
import { HomeData } from '@/view/home/supportScript'
import MainHeader from '../components/common/mainHeader.vue'
import MainFooter from '../components/common/mainFooter.vue'
import GamePopup from '@/view/game/gamePopup.vue'
import ProfilePopup from '@/view/profile/profilePopup.vue'
import PwaAntiBlockingPopup from '../components/common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../components/common/pwaStatusPopup.vue'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import SideNavbar from '../components/sideNav/sideNavbar.vue'
import { playClickSound } from '@/utils/media'
import ClaimListPopup from '../components/common/claimListPopup.vue'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'homeView',
  props: {
    dataSet: {}
  },
  emits: ['setFooterRef', 'goToGamePannel', 'openProfilePopup', 'isComponentVisible', 'installApp', 'isClosedPWA', 'setShowPWA', 'openPWAPopup', 'setGroupListRef', 'resetSelectedGroup', 'goToAgent', 'goToDeposit', 'handleShowTreasurePopup', 'reopenBackgroundRechargePopup', 'resetShowTreasurePopup'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const gamePopupRef = ref()
const profilePopupRef = ref()
const promotionRef = ref();
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const contactRef = ref()
const showGroupGames = ref(false)
const groupListRef = ref()
const sideNavbarRef = ref()
const showPop = ref()
const props = __props

const emits = __emit

const setFooterRef = (el: any) => {
    emits('setFooterRef', el)
};
const showGames = (item: any) => {
    groupListRef.value.setActiopFunGroup(item)

    const topAnchor = document.getElementById('page-top-anchor');
    if (topAnchor) {
        topAnchor.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

const openProfilePopup = () => {
    emits('openProfilePopup')
}

const closeProfilePoup = () => {
    profilePopupRef.value.close()
}
const goToAgent = () => {
    emits('goToAgent')
}

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup',path)
}
const showGameList = (value: any) => {
    showGroupGames.value = value
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};

const installApp = async () => {
    emits('installApp')
}
const isClosedPWA = async (value: any) => {
    emits('isClosedPWA', value)
}
const setShowPWA = async (value: any) => {
    emits('setShowPWA', value)
}

const openPWAPopup = () => {
    emits('openPWAPopup')
}

const setGroupListRef = (el: any) => {
    emits('setGroupListRef', el)
    groupListRef.value = el
}
const resetSelectedGroup = () => {
    emits('resetSelectedGroup')
}

const gamePoupOpen = (id: number) => {
    gamePopupRef.value.open(id);
}

const profilePoupOpen = (list: any) => {
    profilePopupRef.value.open(list);
}

const pwaPoupOpen = () => {
    pwaPopupRef.value.open()
}

const pwaStatusPoupOpen = (title: string) => {
    pwaPopupStatusRef.value.open(title);
}

const openContactPopup = () => {
    contactRef.value.open()
}

const goToDeposit = () => {
    emits('goToDeposit')
}

const openSidebar = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return false; }
    playClickSound()
    sideNavbarRef.value.openSidebar()
}

const reopenBackgroundRechargePopup = () => {
    emits('reopenBackgroundRechargePopup')
}


const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}

onMounted(() =>{
    showPop.value = false
    setTimeout(()=>{
        showPop.value = true
    },2000)
})
__expose({
    gamePoupOpen,
    profilePoupOpen,
    pwaStatusPoupOpen,
    pwaPoupOpen
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "page-top-anchor" }, null, -1)),
    _createElementVNode("div", {
      class: "home_page",
      style: _normalizeStyle({ paddingTop: _ctx.dataSet.isShowingPWA ? '100px' : '50px' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.componentList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (isComponentVisible(item, 'header'))
            ? (_openBlock(), _createBlock(MainHeader, {
                key: 0,
                onIntallPWA: installApp,
                onIsClosedPWA: isClosedPWA,
                listGameData: _ctx.dataSet.groupList,
                onOpenSidebar: openSidebar,
                onShowPWA: setShowPWA,
                itemData: item,
                onOpenContactPopup: openContactPopup,
                onGoToDeposit: goToDeposit
              }, null, 8, ["listGameData", "itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'banners'))
            ? (_openBlock(), _createBlock(CarousalCard, {
                key: 1,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'notice'))
            ? (_openBlock(), _createBlock(BannerCard, {
                key: 2,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'newsBar'))
            ? (_openBlock(), _createBlock(NoticeBar, {
                key: 3,
                itemData: item
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'gameGroups'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(GroupList, {
                  ref_for: true,
                  ref: el => setGroupListRef(el),
                  listData: _ctx.dataSet.groupList,
                  onShowGameList: showGameList,
                  itemData: item
                }, null, 8, ["listData", "itemData"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.groupList, (subitem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "home_game_panel",
                    key: index
                  }, [
                    (!showGroupGames.value)
                      ? (_openBlock(), _createBlock(GamePanel, {
                          key: 0,
                          groupImage: subitem.customIcon,
                          groupName: subitem.name,
                          gameList: subitem.games,
                          itemData: item,
                          onShowGames: ($event: any) => (showGames(subitem)),
                          itemIndex: index
                        }, null, 8, ["groupImage", "groupName", "gameList", "itemData", "onShowGames", "itemIndex"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'footerText'))
            ? (_openBlock(), _createBlock(FooterText, {
                key: 5,
                itemData: item,
                onOpenContactPopup: openContactPopup
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true),
          (isComponentVisible(item, 'footer'))
            ? (_openBlock(), _createBlock(MainFooter, {
                key: 6,
                onGoToProfile: openProfilePopup,
                itemData: item,
                onProfileClose: closeProfilePoup,
                ref_for: true,
                ref: setFooterRef,
                onOpenPWA: openPWAPopup,
                onReopenBackgroundRechargePopup: reopenBackgroundRechargePopup
              }, null, 8, ["itemData"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 4),
    _createVNode(FloatButton, {
      onOpenAgentPopup: goToAgent,
      onOpenPWA: openPWAPopup,
      onHandleShowTreasurePopup: handleShowTreasurePopup
    }),
    _createVNode(SideNavbar, {
      ref_key: "sideNavbarRef",
      ref: sideNavbarRef,
      listGameData: _ctx.dataSet.groupList,
      onIntallPWA: installApp,
      onOpenContactPopup: openContactPopup
    }, null, 8, ["listGameData"]),
    _createVNode(GamePopup, {
      ref_key: "gamePopupRef",
      ref: gamePopupRef,
      onResetSelectedGroup: resetSelectedGroup,
      onGoToProfile: openProfilePopup
    }, null, 512),
    _createVNode(ProfilePopup, {
      ref_key: "profilePopupRef",
      ref: profilePopupRef,
      onOpenAgentPopup: goToAgent
    }, null, 512),
    _createVNode(PromotionPopup, {
      ref_key: "promotionRef",
      ref: promotionRef,
      onOpenAgentPopup: goToAgent,
      onOpenPWA: openPWAPopup
    }, null, 512),
    _createVNode(PwaAntiBlockingPopup, {
      ref_key: "pwaPopupRef",
      ref: pwaPopupRef
    }, null, 512),
    _createVNode(PwaStatusPopup, {
      ref_key: "pwaPopupStatusRef",
      ref: pwaPopupStatusRef
    }, null, 512),
    _createVNode(ContactServicePopup, {
      ref_key: "contactRef",
      ref: contactRef
    }, null, 512),
    (showPop.value && _unref(userStore).allActivityBonusPopup && _unref(userStore).claimActivityList.length > 0 && !_unref(userStore).pwaShowing && _unref(userStore).isInHome)
      ? (_openBlock(), _createBlock(ClaimListPopup, {
          key: 0,
          ref: "claimListPopupRef",
          onHandleShowTreasurePopup: handleShowTreasurePopup,
          onResetShowTreasurePopup: resetShowTreasurePopup
        }, null, 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})